// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "劳动与创造",
      "tec": "田丰",
      "week": "18周",
      "add": "教学楼C座305教务"
    },
    [
      {
        "sub": "传感器与检测技术",
        "tec": "朱雪枫",
        "week": "1-16周",
        "add": "教学楼B座222自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "田丰",
        "week": "18周",
        "add": "教学楼C座305教务"
      }
    ],
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "周彩虹",
        "week": "1-8周",
        "add": "教学楼A座225电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "周彩虹",
        "week": "11-14周",
        "add": "教学楼A座225电力"
      }
    ],
    0,
    0
  ],
  "2": [
    {
      "sub": "操作系统原理",
      "tec": "才九荣",
      "week": "1-16周",
      "add": "实训楼F座201自控"
    },
    0,
    0,
    {
      "sub": "RFID原理及应用",
      "tec": "宋敏",
      "week": "1-16单周",
      "add": "实训楼F座303信息"
    },
    0
  ],
  "3": [
    [
      {
        "sub": "算法竞赛",
        "tec": "周强",
        "week": "1-8周",
        "add": "教学楼C座402管理"
      },
      {
        "sub": "劳动与创造",
        "tec": "田丰",
        "week": "18周",
        "add": "教学楼C座303教务"
      }
    ],
    [
      {
        "sub": "就业创业指导",
        "tec": "于天宇",
        "week": "1-5周",
        "add": "教学楼C座213教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "田丰",
        "week": "18周",
        "add": "教学楼C座303教务"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "传感器与检测技术",
      "tec": "朱雪枫",
      "week": "1-16单周",
      "add": "教学楼C座402管理"
    },
    {
      "sub": "物联网通信技术",
      "tec": "富璇",
      "week": "1-12周",
      "add": "实训楼E座317管理"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "操作系统原理",
      "tec": "才九荣",
      "week": "1-16单周",
      "add": "实训楼F座302信息"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "周彩虹",
        "week": "1-8周",
        "add": "教学楼B座425能动"
      },
      {
        "sub": "国家安全教育",
        "tec": "周彩虹",
        "week": "11-14周",
        "add": "教学楼B座425能动"
      }
    ],
    {
      "sub": "RFID原理及应用",
      "tec": "宋敏",
      "week": "1-16周",
      "add": "实训楼F座303信息"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
